import React from 'react';
import { Link } from 'gatsby';
import { Activity } from 'lucide-react';

import { ContentNode } from '../../../../lib/types/content.types';

type FilteredSearchResultProps = {
    filteredPosts: ContentNode[];
    filteredHowtos: ContentNode[];
    filteredSnippets: ContentNode[];
    filteredFridays: ContentNode[];
}

const FilteredSearchResult = ({ filteredPosts, filteredHowtos, filteredSnippets, filteredFridays}: FilteredSearchResultProps) => {
  return (
    <div className="my-2">
       <div className='flex justify-between my-2'>
                <span className='px-2 font-semibold uppercase text-slate-700 dark:text-slate-200 text-lg'>
                  Posts
                </span>
          {filteredPosts.length > 0 && (
            <span className='text-slate-600 dark:text-slate-400 flex justify-end text-lg'>
              {filteredPosts.length} post{filteredPosts.length !== 1 ? 's' : ''} found
            </span>
          )}
         </div>
         <div className="flex flex-col gap-2">
          {
          filteredPosts.map((post) => ( <Link
                      className='group flex items-center rounded px-2 py-1 text-sm leading-6 outline-none focus-within:bg-slate-50 hover:bg-slate-50 dark:focus-within:bg-slate-800 dark:hover:bg-slate-800 text-black dark:text-white'
                      to={`/${post.frontmatter.permalink}`} key={post.id}
                    >
                      <Activity
                        size={12}
                        className='fill-slate-400 dark:fill-slate-600 mr-3 group-hover:animate-pulse group-hover:scale-125'
                      />
                      {post.frontmatter.title}
                    </Link>
          ))
          }
         </div>
           {filteredHowtos.length > 0 && (<><div className='flex justify-between my-2'>
                <span className='px-2 font-semibold uppercase text-slate-700 dark:text-slate-200 text-lg'>
                  Howtos
                </span>
          
            <span className='text-slate-600 dark:text-slate-400 flex justify-end text-lg'>
              {filteredHowtos.length} howto{filteredHowtos.length !== 1 ? 's' : ''} found
            </span>
          
         </div>
         <div className="flex flex-col gap-2">
          
          {filteredHowtos.map((post) => ( <Link
                      className='group flex items-center rounded px-2 py-1 text-sm leading-6 outline-none focus-within:bg-slate-50 hover:bg-slate-50 dark:focus-within:bg-slate-800 dark:hover:bg-slate-800 text-black dark:text-white'
                      to={`/${post.frontmatter.permalink}`} key={post.id}
                    >
                      <Activity
                        size={12}
                        className='fill-slate-400 dark:fill-slate-600 mr-3 group-hover:animate-pulse group-hover:scale-125'
                      />
                      {post.frontmatter.title}
                    </Link>
          ))}
         </div></>
        )}
           {filteredSnippets.length > 0 && (<><div className='flex justify-between my-2'>
                <span className='px-2 font-semibold uppercase text-slate-700 dark:text-slate-200 text-lg'>
                  Snippets
                </span>
          
            <span className='text-slate-600 dark:text-slate-400 flex justify-end text-lg'>
              {filteredSnippets.length} snippet{filteredSnippets.length !== 1 ? 's' : ''} found
            </span>
          
         </div>
         <div className="flex flex-col gap-2">
          
          {filteredSnippets.map((post) => ( <Link
                      className='group flex items-center rounded px-2 py-1 text-sm leading-6 outline-none focus-within:bg-slate-50 hover:bg-slate-50 dark:focus-within:bg-slate-800 dark:hover:bg-slate-800 text-black dark:text-white'
                      to={`/${post.frontmatter.permalink}`} key={post.id}
                    >
                      <Activity
                        size={12}
                        className='fill-slate-400 dark:fill-slate-600 mr-3 group-hover:animate-pulse group-hover:scale-125'
                      />
                      {post.frontmatter.title}
                    </Link>
          ))}
         </div></>
        )}
           {filteredFridays.length > 0 && (<><div className='flex justify-between my-2'>
                <span className='px-2 font-semibold uppercase text-slate-700 dark:text-slate-200 text-lg'>
                  Fridays
                </span>
          
            <span className='text-slate-600 dark:text-slate-400 flex justify-end text-lg'>
              {filteredFridays.length} friday{filteredFridays.length !== 1 ? 's' : ''} found
            </span>
          
         </div>
         <div className="flex flex-col gap-2 mb-12">
          
          {filteredFridays.map((post) => ( <Link
                      className='group flex items-center rounded px-2 py-1 text-sm leading-6 outline-none focus-within:bg-slate-50 hover:bg-slate-50 dark:focus-within:bg-slate-800 dark:hover:bg-slate-800 text-black dark:text-white'
                      to={`/${post.frontmatter.permalink}`} key={post.id}
                    >
                      <Activity
                        size={12}
                        className='fill-slate-400 dark:fill-slate-600 mr-3 group-hover:animate-pulse group-hover:scale-125'
                      />
                      {post.frontmatter.title}
                    </Link>
          ))}
         </div></>
        )}
  </div>
  )
}
export default FilteredSearchResult